import { styled } from '@nx-kit/styling';
import useTranslation from 'next-translate/useTranslation';
import { LOCALES_MAP } from 'prismic/config';
import Icon from 'components/atoms/Icon/Icon';

export interface DateTimeProps {
  date: Date;
  timeslot: string;
  location?: string | null;
}

const DateTimeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px 35px;
  margin-bottom: 10px;
  width: 100%;
`;

const Item = styled.div`
  align-items: center;
  display: flex;
`;

const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.global.color.primary};
  margin-right: 10px;
`;

const dateOptions: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };

export const DateTimeInfo: React.FC<DateTimeProps> = ({ date, timeslot, location }) => {
  const { lang } = useTranslation('common');
  const locale = LOCALES_MAP[lang] ?? LOCALES_MAP.default;
  const formattedDate = date.toLocaleDateString(locale, dateOptions);
  return (
    <DateTimeContainer>
      <Item>
        <StyledIcon name="CALENDAR" />
        <span>{formattedDate}</span>
      </Item>
      {location && (
        <Item>
          <StyledIcon name="MAPCURSOR" />
          <span>{location}</span>
        </Item>
      )}
      <Item>
        <StyledIcon name="CLOCK" />
        <span>{timeslot.replace(/\:/g, '.')}</span>
      </Item>
    </DateTimeContainer>
  );
};
